export default __webpack_public_path__ + "static/media/right-arrow-blck.5345e3a3.svg";